module.exports = __webpack_public_path__ + "static/media/travel.f27a47be.png";